import classNames from 'classnames';
import type React from 'react';
import { useEffect } from 'react';
import { useTabs } from './TabsContext';
import type { TabId } from './types';

export interface TabListProps {
  children: React.ReactNode;
  onChangeTab?: (tab: TabId) => void;
  [key: string]: unknown;
}

export const TabList = ({ children, onChangeTab, ...rest }: TabListProps) => {
  const tabsContext = useTabs();

  useEffect(() => {
    if (onChangeTab) {
      onChangeTab(tabsContext.selectedTabId);
    }
  }, [tabsContext.selectedTabId, onChangeTab]);

  return (
    <ul
      className={classNames('list-none m-0 p-0 flex flex-row')}
      {...rest}
    >
      {children}
    </ul>
  );
};
